export const getSelectedActivity = state => state.selectedActivity.activity;

export const getSendingSearchlight = state => state.appSessionReducer.sendingSearchlight;

// Check if Continue (session refresh) button clicked on Multiple Sessions modal
// refresh_button_selected is a specific Searchlight schema const
export const getIsReportingMultipleSessions = state =>
  getSendingSearchlight(state)?.details?.action === 'refresh_button_selected';
